<template>
  <div class="container bg-white" id="pembaruan">
    <div class="row">
      <div class="col-xs-18">
        <h3>{{ $t('tos.pembaruan.title') }}</h3>
        <div class="divider"></div>
        <p>{{ $t('tos.pembaruan.line1') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pembaruan',
};
</script>
